import { h } from '@debbie/cortex/dist/index.js';
export const load = (l, transform, loader) => {
    const nu = {};
    for (const [key, val] of Object.entries(l)) {
        if (h.hasData(val)) {
            nu[key] = val.data;
        }
        else {
            return loader;
        }
    }
    return transform(nu);
};
//# sourceMappingURL=utils.js.map